<!-- Global SVG gradient definitions ─────────────────────────────────────────
     Referenced by the `.svg-gradient` CSS class (see styles.scss).
     To switch all SVG icons to a gradient, update the stop-color values below
     and add the class `svg-gradient` to any <svg> element.
     ───────────────────────────────────────────────────────────────────────-->
<svg xmlns="http://www.w3.org/2000/svg" width="0" height="0"
     aria-hidden="true" focusable="false"
     style="position:absolute;width:0;height:0;overflow:hidden">
  <defs>
    <!-- Blue (#00AAE6) occupies the left 70%; green (#00AE4B) the right 30%.
         To change the split, move the second stop percentage.
         To switch to a solid color, set both stop-color values to the same value. -->
    <linearGradient id="svg-accent-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
      <stop offset="0%"   stop-color="var(--svg-gradient-from, #00AAE6)" />
      <stop offset="70%"  stop-color="var(--svg-gradient-from, #00AAE6)" />
      <stop offset="100%" stop-color="var(--svg-gradient-to,   #00AE4B)" />
    </linearGradient>
  </defs>
</svg>

<!-- <div class="bg-white flex justify-start flex-col">
  <app-header></app-header>
  <router-outlet class="mt-20"></router-outlet>
  <app-footer class="mt-10"></app-footer>
</div> -->


<router-outlet class="mt-20"></router-outlet>
